import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { NgxGalleryModule } from 'ngx-gallery';
import { NgxCarouselModule } from 'ngx-carousel';
import { TabModule } from 'angular-tabs-component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ScrollToModule } from 'ng2-scroll-to-el';
import { NgsRevealModule } from 'ng-scrollreveal';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AnimateOnScrollModule } from 'ng2-animate-on-scroll';
import { Ng2AnimateScrollModule } from 'ng2-animate-scroll';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Ng2ScrollimateModule } from 'ng2-scrollimate'; 

import { SwiperModule } from 'ngx-swiper-wrapper';
import { SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { DistrictComponent } from './district/district.component';
import { OfficesComponent } from './offices/offices.component';
import { ServicesComponent } from './services/services.component';
import { ContactsComponent } from './contacts/contacts.component';
import { VoyagerHeaderComponent } from './partials/voyager-header/voyager-header.component';
import { VoyagerFooterComponent } from './partials/voyager-footer/voyager-footer.component';
import { VideoModalComponent } from './video-modal/video-modal.component';

import { TransferHttpCacheModule } from '@nguniversal/common';

export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient, './assets/i18n/', '.json');
}

const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DistrictComponent,
    OfficesComponent,
    ServicesComponent,
    ContactsComponent,
    VoyagerHeaderComponent,
    VoyagerFooterComponent,
    VideoModalComponent
  ],
  imports: [
    BrowserModule.withServerTransition({appId: 'voyager'}),
    AppRoutingModule,
    NgxGalleryModule,
    BrowserAnimationsModule,
    NgxCarouselModule,
    SwiperModule,
    TabModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    TransferHttpCacheModule,
    Ng2AnimateScrollModule,
    Ng2ScrollimateModule,
    AnimateOnScrollModule.forRoot(),
    ScrollToModule.forRoot(),
    ModalModule.forRoot(),
    NgsRevealModule.forRoot()
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts